import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Grid,
  Button,
  useMediaQuery,
  Popover,
  Box,
  Badge,
  Avatar,
  Divider,
  Typography
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { KeyboardArrowDown, Person, ExitToApp } from "@mui/icons-material";

import Logo from "../../Assets/images/logow2.png";
import Userimage from "../userimage/Userimage";
import userProfileImage from "../../Assets/images/user-profile.jpg";
import Search from "../search/Search";
import { userLogout } from "../../../action/userActions";

import axiosInstance from "../../../utils/axios/axiosInstance";
import API from "../../../config/apiconfig";



const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isLgScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const isSmScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  /* -------------------------------------------------- *
   *                     STATE                         *
   * -------------------------------------------------- */
  const [acctAnchor, setAcctAnchor] = useState(null);
  const [navOpen, setNavOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [profileName, setProfileName] = useState("");
  // NEW: dropdown menu state
  const [navMenuAnchor, setNavMenuAnchor] = useState(null);
  const [currentSubPages, setCurrentSubPages] = useState([]);

  /* -------------------------------------------------- *
   *                HELPERS / HANDLERS                  *
   * -------------------------------------------------- */
  const goTo = (path) => {
    const absolutePath = path.startsWith("/") ? path : `/${path}`;
    navigate(absolutePath);
    handleAcctMenuClose();
    handleNavMenuClose();
    setNavOpen(false);
  };

  const isActive = (path) =>
    path === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(path);

  const handleAcctMenuOpen = (e) => setAcctAnchor(e.currentTarget);
  const handleAcctMenuClose = () => setAcctAnchor(null);

  const toggleNav = () => setNavOpen((o) => !o);
  const handleSearchPopoverOpen = () => setSearchOpen(true);
  const handleSearchPopoverClose = () => setSearchOpen(false);

  // NEW: open/close desktop dropdown
  const handleNavMenuOpen = (e, subPages) => {
    setNavMenuAnchor(e.currentTarget);
    setCurrentSubPages(subPages);
  };
  const handleNavMenuClose = () => {
    setNavMenuAnchor(null);
    setCurrentSubPages([]);
  };

  const handleLogout = () => {
    dispatch(userLogout());
    navigate("/");
    handleAcctMenuClose();
  };

  // Helper function to get user initials for default avatar
  const getUserInitials = (name) => {
    if (!name) return "U";
    return name
      .split(" ")
      .map(word => word.charAt(0).toUpperCase())
      .slice(0, 2)
      .join("");
  };

  /* -------------------------------------------------- *
   *               NAVIGATION DATA                     *
   * -------------------------------------------------- */
    

  const pages = [

{ label: "Home", path: "/" },
  


    { label: "Marketplace", path: "/marketplace" },
    
    {
      label: "Campus & Community",
      path: "/campusandcommunity/events",
      subPages: [
        { label: "Events", path: "/campusandcommunity/events" },
        { label: "Volunteering Opportunities", path: "/campusandcommunity/volunteeroppertunities" },
        { label: "Clubs", path: "/campusandcommunity/clubs" },
        { label: "Forums", path: "/campusandcommunity/forums" }
      ]
    },
        {
      label: "Student tools",
      path: "/studenttools/todolist",
      subPages: [
        { label: "To-Do Lists", path: "/studenttools/todolist" },
        { label: "Sticky Notes", path: "/studenttools/notes" },
        { label: "Quick Links", path: "/studenttools/quicklinks" },
        { label: "Jobs", path: "/studenttools/jobs" },
        { label: "Deals", path: "/studenttools/deals" },
        { label: "My Planner", path: "/studenttools/planner" }
      ]
    },
    
    

  ];

  /* -------------------------------------------------- *
   *               FETCH PROFILE IMAGE                  *
   * -------------------------------------------------- */
  useEffect(() => {
    axiosInstance
      .get(`${API.USER_MANAGEMENT_API_BASE_URL}${API.PROFILE_DETAILS}`)
      .then((res) => {
        const {
          profile_picture: imageUrl,
          name: fetchedName
        } = res?.data?.data || {};
        if (imageUrl) setProfileImage(imageUrl);
        if (fetchedName) setProfileName(fetchedName);
      })
      .catch((err) => console.error("Error fetching profile data:", err));
  }, []);

  /* -------------------------------------------------- *
   *                    RENDER                          *
   * -------------------------------------------------- */
  return (
    <AppBar
      position="sticky"
      elevation={0}
      className="header-new"
      sx={{
        background: "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.9) 100%)",
        backdropFilter: "blur(20px)",
        borderBottom: "1px solid rgba(255,255,255,0.2)",
        color: "#1a1a1a"
      }}
    >
      {/* ---------- TOP BAR ---------- */}
      <Box sx={{ background: "rgba(255,255,255,0.1)", backdropFilter: "blur(10px)" }} className="header-nav">
        <div className="container">
          <Toolbar sx={{ 
            justifyContent: "space-between", 
            py: { xs: 0.5, sm: 1 },
            px: { xs: 1, sm: 2 },
            minHeight: { xs: '56px !important', sm: '64px !important' }
          }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, sm: 2 } }}>
              <img
                src={Logo}
                alt="logo"
                style={{
                  width: isSmScreen ? "100px" : "140px",
                  height: "auto",
                  filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.1))"
                }}
              />
            </Box>

            <Grid 
              display="flex" 
              gap={{ xs: 1, sm: 2 }} 
              alignItems="center"
              sx={{ flexShrink: 0 }}
            >
                <Typography
                  variant="body2"
                  sx={{
                    color: "#fff",
                    fontWeight: 500,
                    fontSize: { xs: "14px", sm: "17px" },
                    maxWidth: { xs: "120px", sm: "180px" },
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    fontFamily:"Saira",
                    marginTop:"5px",
                    "&:hover": {
                      color: "#fff",
                    },
                    display: { xs: "none", sm: "block" }
                  }}
                >
                 Hi, {profileName || "User"}
                </Typography>

              <IconButton 
                className="top-profile-img"
                edge="end"
                sx={{
                  background: "rgba(255,255,255,0.8)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255,255,255,0.3)",
                  width: { xs: 36, sm: 40 },
                  height: { xs: 36, sm: 40 },
                  "&:hover": {
                    background: "rgba(255,255,255,0.95)",
                    transform: "translateY(-2px)"
                  },
                  transition: "all 0.3s ease"
                }}
                disableRipple
              >
                <Badge color="error">
                  <span className="pulse-wrapper">
                    <NotificationsIcon 
                      sx={{ color: "#6366f1" }} 
                      fontSize={isSmScreen ? "small" : "medium"} 
                    />
                    <span className="pulse-dot" />
                  </span>
                </Badge>
              </IconButton>

              <Box
                onClick={handleAcctMenuOpen}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: 0.5, sm: 1 },
                  cursor: "pointer",
                  color: '#fff',
                  minWidth: { xs: 'auto', sm: 'auto' }
                }}
              >
                <Avatar
                  src={profileImage || userProfileImage}
                  sx={{ 
                    width: { xs: 32, sm: 40 }, 
                    height: { xs: 32, sm: 40 },
                    bgcolor: profileImage || userProfileImage ? "transparent" : "#6366f1",
                    color: "#fff",
                    fontSize: { xs: '0.875rem', sm: '1rem' },
                    fontWeight: 600
                  }}
                >
                  {!profileImage && !userProfileImage && getUserInitials(profileName)}
                </Avatar>
              
                <KeyboardArrowDown sx={{
                  fontSize: { xs: 18, sm: 20 }, 
                  color: "#fff",
                  "&:hover": {
                    color: "#fff",
                  },
                }} />
              </Box>

            </Grid>

            {/* Account menu */}
            <Menu
              className="profile-menu"
              anchorEl={acctAnchor}
              open={Boolean(acctAnchor)}
              onClose={handleAcctMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              elevation={0}
              PaperProps={{
                onMouseLeave: handleNavMenuClose,
                sx: {
                  background: "rgba(255,255,255,0.95)",
                  backdropFilter: "blur(20px)",
                  border: "1px solid rgba(255,255,255,0.3)",
                  borderRadius: "12px",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                  minWidth: { xs: 180, sm: 200 },
                  mt: 1,
                  fontFamily: "Saira !important",
                  maxWidth: { xs: '90vw', sm: 'none' }
                }
              }}
            >
              <MenuItem
                onClick={() => goTo("/myaccount/myprofile")}
                selected={isActive("/myaccount")}
                sx={{
                  borderRadius: "8px",
                  mx: 1,
                  my: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  minHeight: { xs: 40, sm: 'auto' },
                  "&:hover": { background: "rgba(99, 102, 241, 0.1)" }
                }}
              >
                <Person fontSize="small" /> My Profile
              </MenuItem>
              <Divider sx={{ my: 1, opacity: 0.3 }} />

              <MenuItem
                onClick={() => goTo("/myaccount/chat")}
                selected={isActive("/chat")}
                sx={{
                  borderRadius: "8px",
                  mx: 1,
                  my: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  minHeight: { xs: 40, sm: 'auto' },
                  "&:hover": { background: "rgba(135, 137, 240, 0.1)" }
                }}
              >
                Chat
              </MenuItem>

              <MenuItem
                onClick={() => goTo("/myaccount/subscription")}
                selected={isActive("/subscription")}
                sx={{
                  borderRadius: "8px",
                  mx: 1,
                  my: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  minHeight: { xs: 40, sm: 'auto' },
                  "&:hover": { background: "rgba(135, 137, 240, 0.1)" }
                }}
              >
                Subscription
              </MenuItem>

              <MenuItem
                onClick={() => goTo("/myaccount/mylisting")}
                selected={isActive("/ads")}
                sx={{
                  borderRadius: "8px",
                  mx: 1,
                  my: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  minHeight: { xs: 40, sm: 'auto' },
                  "&:hover": { background: "rgba(135, 137, 240, 0.1)" }
                }}
              >
                My Listing
              </MenuItem>

              <MenuItem
                onClick={() => goTo("/myaccount/favorite")}
                selected={isActive("/favorite")}
                sx={{
                  borderRadius: "8px",
                  mx: 1,
                  my: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  minHeight: { xs: 40, sm: 'auto' },
                  "&:hover": { background: "rgba(135, 137, 240, 0.1)" }
                }}
              >
                Wishlist
              </MenuItem>

              <MenuItem
                onClick={() => goTo("/myaccount/orders")}
                selected={isActive("/orders")}
                sx={{
                  borderRadius: "8px",
                  mx: 1,
                  my: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  minHeight: { xs: 40, sm: 'auto' },
                  "&:hover": { background: "rgba(135, 137, 240, 0.1)" }
                }}
              >
                Orders
              </MenuItem>

              <Divider sx={{ my: 1, opacity: 0.3 }} />
              <MenuItem
                onClick={handleLogout}
                sx={{
                  borderRadius: "8px",
                  mx: 1,
                  my: 0.5,
                  color: "#ef4444",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  minHeight: { xs: 40, sm: 'auto' },
                  "&:hover": { background: "rgba(239, 68, 68, 0.1)" }
                }}
              >
                <ExitToApp fontSize="small" /> Logout
              </MenuItem>
            </Menu>
          </Toolbar>
        </div>
      </Box>

      {/* ---------- MAIN NAV (desktop) ---------- */}
      {isLgScreen ? (
        <Box className="nav-new" sx={{ background: "rgba(255,255,255,0.05)" }}>
          {/* Top‐level buttons */}
          <Toolbar variant="dense" sx={{ justifyContent: "center", gap: 1, py: 1 }}>
            {pages.map(({ label, path, subPages }) => (
              <Box
                key={label}
                onMouseEnter={(e) => {
                  if (subPages && subPages.length) {
                    handleNavMenuOpen(e, subPages);    // open this submenu
                  } else {
                    handleNavMenuClose();              // close old submenu
                  }
                }}
              >
                <Button
                  color="inherit"
                  onClick={!subPages ? () => goTo(path) : undefined}
                  sx={{ cursor: "pointer", px: 3, py: 1, borderRadius: "25px", textTransform: "none" }}
                  endIcon={subPages ? <KeyboardArrowDown /> : null}
                >
                  {label}
                </Button>
              </Box>
            ))}
          </Toolbar>

          <Menu
            key={currentSubPages[0]?.path || "none"}        // force fresh remount on each hover
            sx={{ pointerEvents: "none" }}                   // let pointer events pass through everywhere except the paper
            anchorEl={navMenuAnchor}
            open={Boolean(navMenuAnchor) && currentSubPages.length > 0}
            onClose={handleNavMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}

            /* ← Attach onMouseLeave directly to the list inside the popover */
            MenuListProps={{
              onMouseLeave: handleNavMenuClose             // close when you truly leave the dropdown list
            }}
            PaperProps={{
              // remove the 8px gap so you never leave the hover zone
              sx: {
                pointerEvents: "auto",                     // re-enable events inside the menu itself
                mt: 0,
                borderRadius: 2,
                minWidth: 160,
                boxShadow: "0px 5px 15px rgba(0,0,0,0.1)"
              }
            }}
          >
            {currentSubPages.map(({ label: sLabel, path: sPath }) => (
              <MenuItem className="sub-menu"
                key={sPath}
                onClick={() => goTo(sPath)}
                selected={isActive(sPath)}
                sx={{ cursor: "pointer", "&:hover": { background: "rgba(99,102,241,0.1)" } }}
              >
                {sLabel}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      ) : (
        /* ---------- HAMBURGER NAV (mobile) ---------- */
        <>
          <Toolbar 
            variant="dense" 
            sx={{ 
              justifyContent: "space-between",
              px: { xs: 1, sm: 2 },
              minHeight: { xs: '48px !important', sm: '56px !important' }
            }}
          >
            <IconButton
              edge="start"
              onClick={toggleNav}
              sx={{
                background: "rgba(255,255,255,0.8)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255,255,255,0.3)",
                width: { xs: 40, sm: 44 },
                height: { xs: 40, sm: 44 },
                "&:hover": { background: "rgba(255,255,255,0.95)", transform: "scale(1.05)" },
                transition: "all 0.3s ease"
              }}
            >
              <MenuIcon sx={{ color: "#6366f1", fontSize: { xs: '1.25rem', sm: '1.5rem' } }} />
            </IconButton>
          </Toolbar>

          {navOpen && (
            <Box
              component="nav"
              sx={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                width: "100%",
                background: "rgba(255,255,255,0.95)",
                backdropFilter: "blur(20px)",
                zIndex: (theme) => theme.zIndex.appBar - 1,
                p: { xs: 1, sm: 2 },
                maxHeight: { xs: '70vh', sm: '80vh' },
                overflowY: 'auto',
                borderBottom: "1px solid rgba(255,255,255,0.2)"
              }}
            >
              <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                {pages.map(({ label, path, subPages }) => (
                  <li key={label} style={{ marginBottom: 8 }}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        goTo(path);
                      }}
                      style={{
                        textDecoration: "none",
                        color: isActive(path) ? "#6366f1" : "#374151",
                        fontWeight: isActive(path) ? 600 : 500,
                        display: "block",
                        padding: isSmScreen ? "12px 16px" : "8px 12px",
                        borderRadius: 6,
                        fontSize: isSmScreen ? "16px" : "14px",
                        minHeight: isSmScreen ? "44px" : "auto",
                        lineHeight: isSmScreen ? "20px" : "normal",
                        backgroundColor: isActive(path) ? "rgba(99,102,241,0.1)" : "transparent"
                      }}
                    >
                      {label}
                    </a>
                    {subPages && (
                      <ul style={{ 
                        listStyle: "none", 
                        paddingLeft: isSmScreen ? 24 : 16, 
                        marginTop: 4,
                        borderLeft: "2px solid rgba(99,102,241,0.2)",
                        marginLeft: isSmScreen ? 16 : 12
                      }}>
                        {subPages.map(({ label: sLabel, path: sPath }) => (
                          <li key={sLabel} style={{ marginBottom: 4 }}>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                goTo(sPath);
                              }}
                              style={{
                                textDecoration: "none",
                                color: isActive(sPath) ? "#6366f1" : "#4B5563",
                                fontSize: isSmScreen ? "14px" : "0.9rem",
                                display: "block",
                                padding: isSmScreen ? "8px 12px" : "4px 8px",
                                borderRadius: 4,
                                minHeight: isSmScreen ? "36px" : "auto",
                                lineHeight: isSmScreen ? "20px" : "normal",
                                backgroundColor: isActive(sPath) ? "rgba(99,102,241,0.1)" : "transparent"
                              }}
                            >
                              {sLabel}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </Box>
          )}
        </>
      )
      }

      {/* ---------- SEARCH POPOVER ---------- */}
      <Popover
        open={searchOpen}
        anchorEl={null}
        onClose={handleSearchPopoverClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{
          sx: {
            width: { xs: "95%", sm: "90%" },
            maxWidth: "800px",
            p: 0,
            background: "rgba(255,255,255,0.95)",
            backdropFilter: "blur(20px)",
            border: "1px solid rgba(255,255,255,0.3)",
            borderRadius: "12px",
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)"
          }
        }}
      >
        <Search />
      </Popover>
    </AppBar >
  );
};

export default Header;